import { connect } from 'react-redux';
import Category2Detail from '../../components/Products/Category2Detail';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

function mapStateToProps(state) {
  return {
    category2Products: state.products.category2Products,
    category2ProductsIsLoading: state.products.category2ProductsIsLoading,
    category2Id: state.products.category2Id,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
  };
}

export default connect(mapStateToProps, { checkPassword, clearCheckPassword })(Category2Detail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/Category2Detail.jsx